import { Button, Typography } from "@kaltura/ds-react-components";
import { translate } from "@kaltura/mediaspace-shared-utils";
import styled from "@emotion/styled";
import { ArrowRight24Icon } from "@kaltura/ds-react-icons";

interface PostRegistrationActionsProps {
    isLastStep: boolean;
    stepMessage?: string;
    onNext: () => void;
}

const StyledBottomInnerContent = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
}));

export const PostRegistrationActions = ({ isLastStep, stepMessage, onNext }: PostRegistrationActionsProps) => {
    const baseClassName = "kms-ds-post-registration-actions";

    return (
        <StyledBottomInnerContent className={`${baseClassName}`}>
            <Button
                color={"primary"}
                size={"large"}
                onClick={onNext}
                startIcon={<ArrowRight24Icon />}
                className={`${baseClassName}-all-done-button`}
            >
                {isLastStep ? translate("All done") : translate("Next")}
            </Button>
            <Typography variant={"body2"} className={`${baseClassName}-step-message`}>
                {stepMessage}
            </Typography>
        </StyledBottomInnerContent>
    );
};
